const routes = [
  {
    path: "/gestor/notificacoes",
    component: () => import("@/components/notificacao/Notificacao.vue"),
    meta: {
      title: "Notificação",
    },
  },
];

export default routes;
